<template>
  <div class="wrapper">
    <div class="text-center max-w-3xl">
      <h1 class="text-2xl">
        Woops. Your session may have expired or there was some other error. Signing out and back in again may resolve this error.
      </h1>
      <p v-html="callText" class="text-muted mt-5"></p>
    </div>
    <router-link :to="homePath()">
      <div class="btn btn-primary">Go Back to Home Page</div>
    </router-link>
  </div>
</template>

<script>
import routeManager from "@/router/route-manager";

export default {
  name: 'Forbidden',
  methods: {
    homePath() {
      return routeManager.homePath();
    }
  },
  computed: {
    callText() {
      return `For assistance, please contact our Customer Care Team at  <a href="tel:8558220269">855.822.0269</a> or <a href="mailto:support@truemarketinsiders.com">support@truemarketinsiders.com.</a>`
    },
  },
}
</script>

<style scoped lang="scss">
.wrapper {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  padding: 50px 0 75px 0;
  min-height: 70vh;
}
</style>
